import { lazy } from "react";
// import CTIPopup from "./CTIPopup/CTIPopup";
// import CTIPopupAddEdit from "./CTIPopup/CTIPopupAddEdit";
// import Integration from "./Integration";
// import IntegrationAddEdit from "./IntegrationAddEdit"
// import IntegrationConfigureForm from "./IntegrationConfigureForm";
// import WebHook from "./WebHook/WebHook"
// import WebHookAddEdit from "./WebHook/WebHookAddEdit";

const WebHook = lazy(() =>
  import(/* webpackChunkName: "WebHook" */ "./WebHook/WebHook")
);
const WebHookAddEdit = lazy(() =>
  import(/* webpackChunkName: "WebHookAddEdit" */ "./WebHook/WebHookAddEdit")
);
const Integration = lazy(() =>
  import(/* webpackChunkName: "Integration" */ "./Integration")
);
const IntegrationAddEdit = lazy(() =>
  import(/* webpackChunkName: "IntegrationAddEdit" */ "./IntegrationAddEdit")
);
const IntegrationConfigureForm = lazy(() =>
  import(
    /* webpackChunkName: "IntegrationConfigureForm" */ "./IntegrationConfigureForm"
  )
);
const CTIPopupAddEdit = lazy(() =>
  import(/* webpackChunkName: "CTIPopupAddEdit" */ "./CTIPopup/CTIPopupAddEdit")
);
const CTIPopup = lazy(() =>
  import(/* webpackChunkName: "CTIPopup" */ "./CTIPopup/CTIPopup")
);
const GuideWire = lazy(() =>
  import(/* webpackChunkName: "GuideWire" */ "./GuideWire/GuideWire")
);
const GuideWireAddEdit = lazy(() =>
  import(
    /* webpackChunkName: "GuideWireAddEdit" */ "./GuideWire/GuideWireAddEdit"
  )
);

const Salesforce = lazy(() =>
  import(/* webpackChunkName: "Salesforce" */ "./Salesforce/Salesforce")
);
const SalesforceAddEdit = lazy(() =>
  import(
    /* webpackChunkName: "SalesforceAddEdit" */ "./Salesforce/SalesforceAddEdit"
  )
);
const SalesforceAuth = lazy(() =>
  import(/* webpackChunkName: "SalesforceAuth" */ "./Salesforce/SalesforceAuth")
);

const Sharepoint = lazy(() =>
  import(/* webpackChunkName: "Sharepoint" */ "./Sharepoint/Sharepoint")
);
const SharepointAddEdit = lazy(() =>
  import(
    /* webpackChunkName: "SharepointAddEdit" */ "./Sharepoint/SharepointAddEdit"
  )
);
const SharepointAuth = lazy(() =>
  import(/* webpackChunkName: "SharepointAuth" */ "./Sharepoint/SharepointAuth")
);

const Snowflake = lazy(() =>
  import(/* webpackChunkName: "Snowflake" */ "./Snowflake/Snowflake")
);
const SnowflakeAddEdit = lazy(() =>
  import(
    /* webpackChunkName: "SnowflakeAddEdit" */ "./Snowflake/SnowflakeAddEdit"
  )
);

export {
  Integration,
  IntegrationConfigureForm,
  IntegrationAddEdit,
  WebHook,
  WebHookAddEdit,
  CTIPopup,
  CTIPopupAddEdit,
  GuideWire,
  GuideWireAddEdit,
  Salesforce,
  SalesforceAddEdit,
  SalesforceAuth,
  Sharepoint,
  SharepointAddEdit,
  SharepointAuth,
  Snowflake,
  SnowflakeAddEdit,
};



// WEBPACK FOOTER //
// src/modules/screens/settings/Integrations/components/index.js